'use client';

import { VaultList } from 'structure/pv2/dynavault/components/VaultList';
import { TopBanner } from 'structure/pv2/dynavault/components/TopBanner';
import { BaseLayout } from 'structure/Layouts/SFILayouts/BaseLayout/BaseLayout';
import { VaultListProvider } from 'structure/pv2/dynavault/context/VaultListContext';
import { VaultListControls } from 'structure/pv2/dynavault/components/VaultListControls';

export default function DashboardPage() {
  return (
    <BaseLayout>
      <TopBanner />
      <VaultListProvider>
        <VaultListControls />
        <div className='mt-3 lg:mt-6'>
          <VaultList />
        </div>
      </VaultListProvider>
    </BaseLayout>
  );
}
